/**
 * The master config editor's header button: "Override all containers" with
 * how many have their own values; it opens the push confirm. Disabled with
 * its reason when every container already follows, or when the master's
 * edits cannot be saved as they stand. Nothing in a container's editor.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { Layers } from 'lucide-react';

import { Badge, Button, Tooltip } from '@/components/ui';

import { useMasterPush } from './master-push-context';

export const PushAllButton: FC = () => {
  const push = useMasterPush();
  if (!push.active) return null;
  const count = push.owners().length;
  const blocked = count === 0 ? `Every container follows ${push.masterName} — none has its own values` : push.blocked();
  const tip = blocked ?? `${count} container${count === 1 ? ' has its' : 's have their'} own values — give ${count === 1 ? 'it' : 'them all'} ${push.masterName}’s`;
  return (
    <Tooltip content={tip}>
      <span>
        <Button variant="outline" size="sm" disabled={Boolean(blocked)} onClick={() => push.ask()}>
          <Layers className="mr-1.5 h-3.5 w-3.5" aria-hidden /> Override all containers
          {count > 0 ? (
            <Badge tone="warning" className="ml-1.5 tabular-nums">
              {count}
            </Badge>
          ) : null}
        </Button>
      </span>
    </Tooltip>
  );
};
